interface TaxSlab {
	from: number;
	to: number | null;
	rate: number;
}

const newTaxRegimeSlabs: TaxSlab[] = [
	{ from: 0, to: 400000, rate: 0 },
	{ from: 400001, to: 800000, rate: 5 },
	{ from: 800001, to: 1200000, rate: 10 },
	{ from: 1200001, to: 1600000, rate: 15 },
	{ from: 1600001, to: 2000000, rate: 20 },
	{ from: 2000001, to: 2400000, rate: 25 },
	{ from: 2400001, to: null, rate: 30 },
];

const standardDeductionAmount = 75000;
const rebateThreshold = 1200000; // Taxable income up to which Section 87A rebate applies
const maxGrossIncomeNoTax = 1275000; // ₹12,00,000 + ₹75,000 standard deduction

function getMaxApplicableSlabRate(salary: number): number {
	if (salary <= 0) {
		return 0;
	}

	// Apply standard deduction
	const taxableIncome = Math.max(0, salary - standardDeductionAmount);

	// If gross income is up to ₹12,75,000, effective tax rate is 0% due to Section 87A rebate
	if (salary <= maxGrossIncomeNoTax && taxableIncome <= rebateThreshold) {
		return 0;
	}

	// Find the applicable slab
	for (const slab of newTaxRegimeSlabs) {
		if (slab.to === null) {
			// Highest slab applies if income exceeds the previous slab's upper limit
			return slab.rate;
		}
		if (taxableIncome >= slab.from && taxableIncome <= slab.to) {
			return slab.rate;
		}
	}

	// This line should not be reached due to the null check in the last slab
	return newTaxRegimeSlabs[newTaxRegimeSlabs.length - 1].rate;
}

export default getMaxApplicableSlabRate;
